/* istanbul ignore file */
import VueVirtualScroller from 'vue-virtual-scroller'

export default VueVirtualScroller
